import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, errMsg } from "../../lib/api";
import { useAdminGuard, AdminTop } from "./AdminDashboard";

export default function LocationForm() {
  const ready = useAdminGuard();
  const { id } = useParams();
  const isNew = id === "new";
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ name: "", address: "", city: "", state: "TX", zip: "", phone: "", notes: "", sort_order: 0 });

  useEffect(() => {
    if (!ready || isNew) return;
    api.get("/locations").then((r) => {
      const l = r.data.find((x) => x.id === id);
      if (l) setF({ name: l.name || "", address: l.address || "", city: l.city || "", state: l.state || "TX",
        zip: l.zip || "", phone: l.phone || "", notes: l.notes || "", sort_order: l.sort_order || 0 });
    });
  }, [ready, id, isNew]);

  const on = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name) { setError("Location name is required."); return; }
    setBusy(true); setError(null);
    const body = { ...f, sort_order: parseInt(f.sort_order) || 0 };
    try {
      if (isNew) await api.post("/admin/locations", body);
      else await api.put(`/admin/locations/${id}`, body);
      navigate("/admin/dashboard");
    } catch (err) { setError(errMsg(err)); setBusy(false); }
  };

  if (!ready) return <div className="loading">Loading…</div>;

  return (
    <div className="adm">
      <AdminTop />
      <main className="admin-wrap narrow">
        <button className="btn-mini" onClick={() => navigate("/admin/dashboard")} style={{ width: "fit-content" }}>← Back to dashboard</button>
        <h1>{isNew ? "New location" : "Edit location"}</h1>
        {error && <div className="msg err">{error}</div>}
        <form onSubmit={submit} data-testid="location-form">
          <label>Name <input type="text" value={f.name} onChange={on("name")} required data-testid="location-name" /></label>
          <label>Street address <input type="text" value={f.address} onChange={on("address")} data-testid="location-address" /></label>
          <div className="form-three">
            <label>City <input type="text" value={f.city} onChange={on("city")} data-testid="location-city" /></label>
            <label>State <input type="text" value={f.state} onChange={on("state")} data-testid="location-state" /></label>
            <label>ZIP <input type="text" value={f.zip} onChange={on("zip")} data-testid="location-zip" /></label>
          </div>
          <div className="form-two">
            <label>Phone <input type="text" value={f.phone} onChange={on("phone")} data-testid="location-phone" /></label>
            <label>Sort order <input type="number" value={f.sort_order} onChange={on("sort_order")} data-testid="location-sort" /></label>
          </div>
          <label>Notes <textarea rows={3} value={f.notes} onChange={on("notes")} data-testid="location-notes" /></label>
          <button type="submit" className="btn-primary" disabled={busy} data-testid="location-save">{busy ? "Saving…" : "Save location"}</button>
        </form>
      </main>
    </div>
  );
}
